module.exports = __webpack_public_path__ + "img/habit_logo.61cc0289.png";